function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1.06,
  y1: 1,
  x2: 0.297,
  y2: 0.052,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd803"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fc4317"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M990.33,355.311a1.843,1.843,0,0,0-.656.124L906.3,387.5a1.8,1.8,0,0,0-.1,3.318L937.338,405.4l46.415-42.1a.251.251,0,0,1,.355.355l-42.1,46.415L956.6,443.333a1.8,1.8,0,0,0,3.341-.077L992,357.748A1.8,1.8,0,0,0,990.33,355.311Z",
  transform: "translate(-905.146 -355.311)",
  fill: "url(#linear-gradient)"
});

var SvgMessages = function SvgMessages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86.978,
    height: 89.113,
    viewBox: "0 0 86.978 89.113",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Messages.d9d330fa.svg";
export { ForwardRef as ReactComponent };